getSafeValue